import { makeStyles, tokens, mergeClasses, Button, Spinner, Tooltip } from "@fluentui/react-components";

const useStyles = makeStyles({
    buttonNonInteractive: {
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralBackground1Pressed}`,
        color: tokens.colorNeutralForeground1,
        cursor: "default",
        pointerEvents: "none",
    },
});

type LoadingButtonProps = {
    text?: string,
    appearance?: "secondary" | "primary" | "outline" | "subtle" | "transparent" | undefined,
    disabled?: boolean,
    loading?: boolean,
    className?: string,
    onClick?: () => void,
    icon?: JSX.Element,
    shape?: "circular" | "rounded" | "square" | undefined,
    tooltip?: string,
};

export default function LoadingButton({ onClick, loading, text, appearance, disabled, className, icon, shape, tooltip }: LoadingButtonProps) {
    const styles = useStyles();

    return (
        <Tooltip content={tooltip ?? ''} relationship="label" withArrow visible={!!tooltip}>
            <Button
                className={loading ? mergeClasses(className, styles.buttonNonInteractive) : className}
                disabled={disabled}
                appearance={appearance}
                disabledFocusable={loading}
                icon={loading ? <Spinner size="tiny" /> : icon}
                shape={shape}
                onClick={onClick}
            >
                {text}
            </Button>
        </Tooltip>
    );
}